export default "__VITE_ASSET__BC2aWmh8__"